import React, { useEffect, useState } from 'react';
import {
  Stack,
  Box,
  Typography,
  CircularProgress,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Card,
  CardContent,
  CardHeader,
  Avatar
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { api } from 'src/Api';
import TransactionStatusDropDown from 'src/layouts/dashboard/TransactionStatusDropdown';

export default function TransactionModal({ handleClose, user_id }) {
  const [loading, setloading] = useState(false);
  const [list, setlist] = useState([]);
  const [selectedStatus, setselectedStatus] = useState('pending');

  function getTransactions(status) {
    setloading(true);

    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', 'Bearer ' + token);

    const params = new URLSearchParams();
    params.append('user_id', user_id);
    params.append('status', status);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${api.get_transactions}?${params.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          throw new Error('Failed to fetch data');
        }
      })
      .then((result) => {
        setlist(result.data);
      })
      .catch((error) => {
        setlist([]);
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  useEffect(() => {
    getTransactions('pending');
  }, []);

  return (
    <Box style={{ padding: 20, width: '100%' }}>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom textAlign={'center'}>
          Transactions
        </Typography>
        <TransactionStatusDropDown
          setData={(val) => {
            setselectedStatus(val);
            getTransactions(val);
          }}
          fullWidth={true}
          default_value={selectedStatus}
        />
        {loading ? (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: 30
            }}
          >
            <CircularProgress />
          </Box>
        ) : list.length > 0 ? (
          list.map((item, index) => {
            const { order, amount, remarks } = item;
            const { product, order_no } = order;
            const orderDetailsList = order?.order_details;
            console.log('order deteil', item);
            return (
              <Card key={index} sx={{ marginBottom: 2 }}>
                <CardContent style={{ padding: 0 }}>
                  <Accordion
                    key={index}
                    style={{
                      margin: 0,
                      boxShadow: 'none',
                      border: 'none'
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-header`}
                      style={{ paddingTop: 5 }}
                    >
                      <Box>
                        <Box style={{ display: 'flex', width: '100%' }}>
                          <Typography style={{ marginRight: '4px' }}>Order No:</Typography>
                          <Typography style={{ textTransform: 'uppercase', marginRight: '4px' }}>
                            {order_no || 'N/A'}
                          </Typography>
                          {/* <Typography style={{ marginRight: '4px' }}>-----</Typography>
                          <Typography>Total (LKR): {amount || 'N/A'} </Typography> */}
                        </Box>
                        <Typography>
                          {' '}
                          Item Price (LKR): {order?.over_all_sum?.products_price || 'N/A'}{' '}
                        </Typography>
                        {/* <Typography>{order?.over_all_sum?.products_price || 'N/A'}</Typography> */}
                        <Typography>
                          {' '}
                          Delivery Fee (LKR): {order?.over_all_sum?.delivery_fee}{' '}
                        </Typography>
                        <Typography>
                          {' '}
                          Total (LKR):{' '}
                          {parseFloat(order?.over_all_sum?.delivery_fee) +
                            parseFloat(order?.over_all_sum?.products_price)}{' '}
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails style={{ padding: 0 }}>
                      <Table sx={{ width: '100%' }} aria-label="products table">
                        <TableHead>
                          <TableRow>
                            <TableCell>{`Products (${orderDetailsList?.length})`}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orderDetailsList?.map((val, idx) => (
                            <TableRow hover key={idx}>
                              <TableCell>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center'
                                  }}
                                >
                                  <Avatar
                                    alt="User Name"
                                    src={val?.product?.media?.media}
                                    sx={{ width: 35, height: 35, marginLeft: 1 }}
                                  />
                                  <div>
                                    <Typography
                                      variant="body2"
                                      noWrap
                                      sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        marginLeft: 1,
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      {val?.product?.name}
                                    </Typography>
                                    <Typography
                                      noWrap
                                      sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        marginLeft: 1,
                                        fontSize: 12
                                      }}
                                    >
                                      {val?.product?.code}
                                    </Typography>
                                  </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                </CardContent>
              </Card>
            );
          })
        ) : (
          <Typography variant="h6" gutterBottom textAlign={'center'} style={{ paddingTop: 30 }}>
            No Transactions Found
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%'
          }}
        >
          <Button onClick={handleClose} variant="outlined">
            Close
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
